import styled from 'styled-components';

export const HomePageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.5rem;
  color: #000000;
`;

export const SectionBody = styled.div``;

export const HeroSection = styled.section`
  background-color: #000000;
  color: #ffffff;
  padding: 60px 20px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  min-height: 75vh;
`;

export const HeroInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const HeroBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;

  > * {
    width: 100%;
    height: 100%;
    display: block;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const HeroTextBlock = styled.div``;

export const HeroTitle = styled.h1`
  margin: 0 0 16px;
  font-size: 2rem;
`;

export const HeroSubtitle = styled.p`
  margin: 0 0 12px;
  font-size: 1.1rem;
  color: #f5f5f5;
`;

export const HeroBody = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: #e0e0e0;
`;

export const HeroImages = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgramsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ProgramCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
`;

export const ProgramTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 1.1rem;
  color: #000000;
`;

export const ProgramDescription = styled.p`
  margin: 0;
  font-size: 0.9rem;
`;

export const TestimoniesList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const TestimonyCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  font-size: 0.9rem;
`;

export const TestimonyTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 1rem;
`;

export const TestimonyMeta = styled.div`
  margin-bottom: 8px;
  font-size: 0.8rem;
  color: #555555;
`;

export const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 24px;
`;

export const StatItem = styled.div`
  flex: 1 1 160px;
  min-width: 160px;
  text-align: center;
`;

export const StatNumber = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 4px;
`;

export const StatLabel = styled.div`
  font-size: 0.9rem;
`;

export const AboutTwoColumn = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 24px;
  margin-top: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const AboutTextBlock = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const AboutImageBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const HomeImageFrame = styled.div`
  width: 100%;
  max-width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  background-color: #000000;
  aspect-ratio: 4 / 3;

  > * {
    width: 100%;
    height: 100%;
    display: block;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ActivitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  background-color: #ffd600;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ActivitiesColumn = styled.div``;

export const ActivitiesColumnTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ActivitiesCard = styled.div`
  background-color: #0d1b2a;
  color: #ffffff;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.9rem;

  & + & {
    margin-top: 8px;
  }
`;

export const ActivitiesItemTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const ActivitiesItemMeta = styled.div`
  font-size: 0.8rem;
  margin-bottom: 4px;
  opacity: 0.9;
`;

export const ActivitiesItemDescription = styled.p`
  margin: 0;
  font-size: 0.9rem;
`;
